import React, {useState, useEffect, Component} from 'react';
import {View, Text} from 'react-native';
import Requests from '../api/Requests';
import {TableContainer} from '../components/table/Table';
import styled, {css} from 'styled-components/native';
import {colours} from '../styles/Style';
import {
  GetGlobalTheme,
  DataTypes,
  WindowTypes,
  IsHRWeb,
  GetParameterID,
  GetDefaultBackBehaviour,
  WindowWrap,
  DisplayBrowseOKFlag,
  GetApprovalStatusText,
  IsHRiOS,
  goBack,
  DoNavigate,
  ScreenHeight,
  ScreenWidth,
  UsePagination,
  ResetRecord,
} from '../Tools/DisplayTools';
import {ActionButton} from '../components/button/ActionButton';
import {InspectWindow} from '../components/edit_elements/InspectWindow';
import {b64toBlob} from '../Tools/Base64Decode';
import EditField from '../components/edit_elements/EditField';
import {translate} from '../Tools/LanguageTools';
import {SetCurrentWindow2, AddDateFilter} from '../Tools/WindowTools';
import {Modal} from 'react-native';
import {YesNoWindow} from '../components/status/YesNoWindow';
import {FixRecordMissingFields} from '../Tools/RecordTools';
import {createDrawerNavigator} from '@react-navigation/drawer';

const kDefPerPage = 20;
const Drawer = createDrawerNavigator();

function OrderHeaderFields(table) {
  let apprf = table.state.ApprovalStatus == '3';
  let empfilter = {};
  if (table.state.record) {
    if (table.state.record.FilterType === undefined) {
      table.state.record.FilterType = '0';
    }
    switch (table.state.record.FilterType) {
      case '1':
        empfilter = {
          title: translate('Department'),
          dataKey: 'FilterString',
          viewOnly: apprf,
          width: '300px',
          pasteSpecial: 7,
          /*pasteSpecialFields: ['depcode', 'name'],*/
          pasteSpecialHeader: [
            {
              name: translate('Code'),
              width: '35%',
              key: 'DepCode',
              mainkey: 'DepCode',
            },
            {
              width: '65%',
              name: translate('Name'),
              key: 'Name',
            },
          ],
          onChange: table.updateRecordField,
        };
        break;
      case '2':
        empfilter = {
          title: translate('Department'),
          dataKey: 'FilterString',
          viewOnly: apprf,
          width: '300px',
          pasteSpecial: 11,
          pasteSpecialHeader: [
            {
              name: translate('Code'),
              width: '35%',
              key: 'PostCode',
              mainkey: 'PostCode',
            },
            {
              width: '65%',
              name: translate('Name'),
              key: 'PostName',
            },
          ],
          onChange: table.updateRecordField,
        };
        break;
      default:
      case '0':
        empfilter = {
          title: translate('Employees'),
          dataKey: 'EmpCodeRow',
          viewOnly: apprf,
          matrixfield: true,
          width: '700px',
          pasteSpecial: 0,
          pasteSpecialMulti: true,
          pasteSpecialHeader: [
            {
              name: translate('Code'),
              width: '35%',
              key: 'empcode',
              mainkey: 'EmpCode',
            },
            {
              width: '65%',
              name: translate('Name'),
              key: 'name',
            },
          ],
          onChange: table.updateRecordFieldMatrix,
        };
    }
  }

  let res = [
    {
      group: {
        fields: [
          {
            title: translate('Filter'),
            dataKey: 'FilterType',
            viewOnly: apprf,
            width: '300px',
            pasteSpecial: 9992,
            pasteSpecialFields: ['code', 'comment'],
            pasteSpecialNoComment: true,
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [empfilter],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('SerNr'),
            dataKey: 'SerNr',
            viewOnly: true,
            width: '150px',
          },
          {
            title: translate('Date'),
            dataKey: 'TransDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
          {
            title: translate('StartDate'),
            dataKey: 'StartDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
          {
            title: translate('EndDate'),
            dataKey: 'EndDate',
            viewOnly: false,
            width: '150px',
            type: DataTypes.kInputTypeDate,
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Type'),
            dataKey: 'OrdType',
            viewOnly: false,
            width: '500px',
            pasteSpecial: 8,
            pasteSpecialFields: ['ordtype', 'comment'],
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Header'),
            dataKey: 'Header',
            viewOnly: false,
            width: '500px',
            onChange: table.updateRecordField,
          },
        ],
      },
    },
    {
      group: {
        fields: [
          {
            title: translate('Text'),
            dataKey: 'Math',
            viewOnly: false,
            type: DataTypes.kInputTypeLongText,
            width: '500px',
            style: {height: 200},
            onChange: table.updateRecordField,
          },
        ],
      },
    },
  ];

  if (table.CanUseApprovalRules() == 1) {
    let label = '';
    let fields = [
      {
        title: translate('ApprovalStatus'),
        fixedvalue: table.state.ApprovalStatusText,
        viewOnly: true,
        width: '200px',
      },
    ];
    switch (table.state.ApprovalStatus) {
      case '1':
      case '2':
      case '5':
        fields.push({
          title: translate('RequestApproval'),
          action: table.RequestApproval,
          width: '200px',
          type: DataTypes.kInputTypeButton,
        });

        break;
      case '3':
        if (table.state.cancancel) {
          fields.push({
            title: translate('CancelApproval'),
            action: table.cancelApproval,
            width: '150px',
            type: DataTypes.kInputTypeButton,
          });
        }
    }
    res.splice(2, 0, {
      group: {
        fields: fields,
      },
    });
  }

  return res;
}

let FilterView;
if (IsHRWeb()) {
  FilterView = styled.View`
    position: absolute;
    top: 100%;
    right: 0px;
    width: 240px;
    background: ${colours[GetGlobalTheme()].lightBackground};
    padding: 20px;
    flex-direction: column;
    align-items: center;
  `;
} else {
  if (IsHRiOS()) {
    FilterView = styled.View`
      position: absolute;
      height: ${ScreenHeight()};
      width: ${ScreenWidth()};
      background: ${colours[GetGlobalTheme()].lightBackground};
      padding: 6px;
    `;
  } else {
    FilterView = styled.Modal``;
  }
}

const FilterViewInner = styled.View`
  ${IsHRWeb() == false &&
  css`
    height: 100%;
    width: 100%;
    background-color: ${colours[GetGlobalTheme()].siteBackground};
  `};
  ${IsHRiOS() &&
  css`
    padding-top: 50;
  `};
`;

const FilterFields = styled.View`
  ${IsHRWeb() &&
  css`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    /*margin-right: -30px;*/
  `}
`;
const FilterField = styled.View`
  ${IsHRWeb() &&
  css`
    width: 100%;
    /*margin-right: 30px;*/
  `}
`;
const FilterActions = styled.View`
  display: flex;
  ${(IsHRWeb() &&
    css`
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: flex-end;
    `) ||
  css`
    flex-direction: column-reverse;
  `}
`;

class OrdersList extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.createNewOrder = this.createNewOrder.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.renderNewButton = this.renderNewButton.bind(this);
    this._isMounted = true;
    this.table = 2;
    this.ScreenName = 'Orders';
    this.init = true;
    this.state = {
      data: [],
      record: {},
      show: false,
      id: '',
      px: 0,
      py: 0,
      WindowType: WindowTypes.Browse,
      hasapprovals: -1,
      newOrderHelper: false,
      NewEmp: global.userData.deplist != '' ? '' : global.userData.empcode,
      NewOrderType: '',
      update: false,
    };
    this.navigation = props.navigation;
    SetCurrentWindow2('OrderDocs', 'SerNr', 'ascending');
    AddDateFilter('OrderDocs');
  }
  getBrowseListData = () => {
    let self = this;
    Requests.getTableData(this.table, undefined, undefined, undefined, true)
      .then((response) => {
        if (self._isMounted) {
          self.setState({data: response.records});
        }
      })
      .catch((error) => {});
  };
  displayBrowseList = () => {
    this.state.WindowType = WindowTypes.Browse;
    this.getBrowseListData();
  };
  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    DoNavigate(this, 'Orders', true, id);
  };

  createNewOrder = () => {
    let self = this;
    if (this.state.NewOrderType == '' || this.state.NewEmp == '') {
      global.messageBox({
        showMessage: true,
        statusMessage: translate('FillMandFields'),
      });
      return;
    }
    let tdata = {
      record: {
        OrdType: this.state.NewOrderType,
        rows: [
          {
            EmpCodeRow: this.state.NewEmp,
          },
        ],
      },
    };
    Requests.getNewRecord(this.table, tdata)
      .then((response) => {
        self.state.NewEmp = '';
        self.state.NewOrderType = '';
        self.ShowHideNewOrder();
        if (UsePagination() == false) {
          self.getBrowseListData();
        }
        self.rowClick(response.record.SerNr);
      })
      .catch((error) => {});
  };
  ShowHideNewOrder = () => {
    if (this.state.newOrderHelper) {
      global.PopEscapeActions();
      this.setState({newOrderHelper: false});
    } else {
      this.setState({newOrderHelper: true});
      global.PushEscapeActions(() => this.ShowHideNewOrder());
    }
  };
  componentDidMount() {
    let self = this;
    this.focusSubscription = this.props.navigation.addListener('focus', () => {
      SetCurrentWindow2('OrderDocs', '', '');
      if (UsePagination() == false) {
        self.getBrowseListData();
      } else {
        if (self.init == false) {
          self.setState({update: self.state.update ? false : true});
        }
        self.init = false;
      }
    });
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  renderNewButton = () => {
    let self = this;
    let style = {};
    if (IsHRWeb()) {
      style = {marginRight: '20px'};
    }
    let style2 = {};
    if (IsHRiOS()) {
      style2 = {
        left: -this.state.px,
        top: -this.state.py,
      };
    }
    return (
      <View
        key={'orderdoc_new'}
        onLayout={(event) => {
          const layout = event.nativeEvent.layout;
          self.setState({py: layout.y, px: layout.x});
        }}
      >
        {(global.userData.deplist != '' || global.userData.deplist == '') && (
          <ActionButton
            onPress={() => this.ShowHideNewOrder()}
            title={translate('AddNew')}
          />
        )}
        {this.state.newOrderHelper && (
          <FilterView style={style2}>
            <FilterViewInner>
              <FilterFields>
                <FilterField>
                  <EditField
                    title={translate('Type') + '*'}
                    value={this.state.NewOrderType}
                    ps={8}
                    psfields={['OrdType', 'Comment']}
                    onChange={(index, fn, value) =>
                      self.setState({NewOrderType: value})
                    }
                  />
                </FilterField>
                <FilterField>
                  <EditField
                    title={translate('Employee') + '*'}
                    value={this.state.NewEmp}
                    ps={0}
                    psheader={[
                      {
                        name: translate('Code'),
                        width: '35%',
                        key: 'empcode',
                        mainkey: 'EmpCode',
                      },
                      {
                        width: '65%',
                        name: translate('Name'),
                        key: 'name',
                      },
                    ]}
                    onChange={(index, fn, value) =>
                      self.setState({NewEmp: value})
                    }
                  />
                </FilterField>
              </FilterFields>
              <FilterActions>
                <ActionButton
                  style={style}
                  onPress={() => this.ShowHideNewOrder()}
                  title={translate('Cancel')}
                />
                <ActionButton
                  onPress={() => this.createNewOrder()}
                  title={translate('Create')}
                />
              </FilterActions>
            </FilterViewInner>
          </FilterView>
        )}
      </View>
    );
  };
  render() {
    let self = this;
    return (
      <WindowWrap>
        <TableContainer
          table={this.table}
          update={this.state.update}
          data={this.state.data}
          columns={[
            {
              title: translate('SerNr'),
              dataKey: 'sernr',
              sortKey: 'SerNr',
              width: '100px',
            },
            {
              title: translate('Code'),
              dataKey: 'empcode',
              sortKey: 'EmpCode',
              width: '100px',
            },
            {
              title: translate('Name'),
              dataKey: 'name',
              sortKey: 'Name',
              width: '200px',
            },
            {
              title: translate('Header'),
              dataKey: 'header',
              sortKey: 'Header',
              width: '300px',
            },
            {
              title: translate('StartDate'),
              dataKey: 'startdate',
              sortKey: 'StartDate',
              width: '150px',
              type: DataTypes.kInputTypeDate,
            },
            {
              title: translate('EndDate'),
              dataKey: 'enddate',
              sortKey: 'EndDate',
              type: DataTypes.kInputTypeDate,
              width: '150px',
            },
            {
              title: translate('Type'),
              dataKey: 'ordtype',
              sortKey: 'OrdType',
              width: '100px',
            },
            {
              title: translate('ApprovedShort'),
              dataKey: 'okflag',
              sortKey: 'OKFlag',
              width: '70px',
              overwrite: DisplayBrowseOKFlag,
            },
          ]}
          doClick={self.rowClick}
          rowID={'sernr'}
          title={translate(this.ScreenName)}
          width="900px"
          extraContent={this.renderNewButton}
        />
      </WindowWrap>
    );
  }
}

class OrdersRecord extends Component {
  constructor(props) {
    super(props);
    let self = this;
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateRecordField = this.updateRecordField.bind(this);
    this.updateRecordFieldMatrix = this.updateRecordFieldMatrix.bind(this);
    this.rowClick = this.rowClick.bind(this);
    this.cancelApproval = this.cancelApproval.bind(this);
    this.RequestApproval = this.RequestApproval.bind(this);
    this._isMounted = true;
    this.table = 2;
    this.ScreenName = 'Orders';
    this.state = {
      data: [],
      record: {},
      show: false,
      id: '',
      WindowType: WindowTypes.Browse,
      hasapprovals: -1,
      pagination: {
        page: 0,
        perpage: kDefPerPage,
        pages: 0,
        change: function (page) {
          self.changePage(page);
        },
        changePagePeriod: function (value) {
          self.changePagePeriod(value);
        },
      },
    };
    this.navigation = props.navigation;
    if (props.route.params?.id) {
      this.state.ActiveID = props.route.params.id;
      this.rowClick(props.route.params.id);
    }
  }

  setMatrixPagination = (cnt) => {
    this.state.pagination.page = 0;
    this.state.pagination.pages =
      parseInt(cnt / this.state.pagination.perpage) + 1;
  };
  rowClick = (id) => {
    let self = this;
    this.state.WindowType = WindowTypes.Inspect;
    this.state.hasapprovals = -1;
    this.setState({record: {}});
    Requests.getTableData(2, {SerNr: id}, undefined, undefined, true)
      .then((response) => {
        self.setMatrixPagination(response.records[0].rows.length);
        self.setState({
          id: response.records[0]['SerNr'],
          record: response.records[0],
        });
      })
      .catch((error) => {});
  };
  updateRecordField = (rowindex, index, value) => {
    let self = this;
    /*
    if (rowindex > -1) {
      this.state.record.rows[rowindex][index] = value;
    } else {
      this.state.record[index] = value;
    }
*/
    Requests.updateRecordData(this.table, {
      field: index,
      rownr: rowindex,
      value: value,
      id: this.state.record.SerNr,
    })
      .then((response) => {
        if (response.success) {
          let record = FixRecordMissingFields(
            response.record,
            OrderHeaderFields(this)
          );
          /*
          record['Math'] = record['Math'].replace(
            /\\n/g,
            String.fromCharCode(13) + String.fromCharCode(10),
          );
          */
          if (index == 'Math') {
            self.rowClick(this.state.record.SerNr);
          } else {
            self.setState({record: record});
            if (index == 'OrdType') {
              self.state.hasapprovals = -1;
              self.CanUseApprovalRules();
            }
          }
        } else {
          ResetRecord(self, index, rowindex, value);
        }
      })
      .catch((error) => {});
  };
  updateRecordFieldMatrix = (rowindex, index, value) => {
    let self = this;
    let addlist = [];
    let fieldlist = [];
    let remlist = [];

    let valarr = value.split(',');

    valarr.map((field, index) => {
      let foundf = false;
      for (let i = 0; i < this.state.record.rows.length; i++) {
        let id = this.state.record.rows[i].EmpCodeRow;
        if (field == id) {
          foundf = true;
          i = this.state.record.rows;
        }
      }
      if (foundf == false) {
        addlist.push(field);
      }
    });
    for (let i = 0; i < this.state.record.rows.length; i++) {
      let id = this.state.record.rows[i].EmpCodeRow;
      if (valarr.indexOf(id) < 0) {
        remlist.push(i);
      }
    }
    let totcnt = 0;
    let curcnt = 0;
    let rwcnt = this.state.record.rows.length;
    for (let i = 0; i < addlist.length; i++) {
      fieldlist.push({
        field: 'EmpCodeRow',
        rownr: rwcnt,
        value: addlist[i],
      });
      rwcnt++;
    }
    if (fieldlist.length > 0) {
      totcnt++;
    }
    totcnt += remlist.length;
    if (fieldlist.length > 0) {
      Requests.updateRecordData(this.table, {
        list: fieldlist,
        id: this.state.record.SerNr,
      })
        .then((response) => {
          if (response.success) {
            curcnt++;
            if (totcnt == curcnt) {
              self.state.record = {};
              self.setState({record: response.record});
            }
          }
        })
        .catch((error) => {});
    }

    for (let i = remlist.length - 1; i >= 0; i--) {
      Requests.deleteRecordRow(
        this.table,
        this.state.record.SerNr + ':' + remlist[i]
      )
        .then((response) => {
          if (self._isMounted) {
            if (response.success) {
              curcnt++;
              if (totcnt == curcnt) {
                self.rowClick(this.state.record.SerNr);
              }
            }
          }
        })
        .catch((error) => {});
    }
  };

  CanUseApprovalRules = () => {
    let self = this;
    let res = this.state.hasapprovals;
    if (
      this.state.record.SerNr !== undefined &&
      this.state.record.SerNr != ''
    ) {
      if (this.state.hasapprovals == -1) {
        this.state.hasapprovals = 0;
        Requests.doAction('checkapprovalstatus', {
          id: this.state.record.SerNr,
          regname: this.table,
        })
          .then((response) => {
            if (response.record.hasapprovals == '1') {
              self.state.ApprovalStatusText = GetApprovalStatusText(
                response.record.approvalstatus
              );
              self.state.ApprovalStatus = response.record.approvalstatus;
              self.state.cancancel = response.record.cancancel;
              self.setState({hasapprovals: 1});
            }
          })
          .catch((error) => {});
      }
    }
    return res;
  };
  cancelApproval = () => {
    let self = this;
    Requests.doAction('cancelapproval', {
      id: this.state.record.SerNr,
      regname: this.table,
    })
      .then((response) => {
        self.rowClick(self.state.record.SerNr);
      })
      .catch((error) => {});
  };

  RequestApproval = () => {
    let self = this;
    this.state.hasapprovals = -1;
    Requests.doAction('sendforapproval', {
      id: this.state.record.SerNr,
      regname: this.table,
    })
      .then((response) => {
        self.state.hasapprovals = -1;
        self.CanUseApprovalRules();
      })
      .catch((error) => {});
  };

  handleInputChange = (rowindex, index, event) => {
    this.updateRecordField(rowindex, index, event.target.value);
  };

  componentDidUpdate(props) {
    let param_id = GetParameterID(this);
    if (this.state.ActiveID != param_id && param_id != '') {
      this.state.ActiveID = param_id;
      this.rowClick(this.state.ActiveID);
    }
  }
  changePage = (page) => {
    let npagination = this.state.pagination;
    npagination.page = page;
    this.setState({pagination: npagination});
  };
  changePagePeriod = (value) => {
    let npagination = this.state.pagination;
    npagination.perpage = value;
    npagination.page = 0;
    this.setMatrixPagination(this.state.record.rows.length);
    this.setState({pagination: npagination});
  };
  deleteRecord = () => {
    let self = this;
    this.setState({activeDelete: false});
    Requests.deleteRecord(this.table, this.state.record.SerNr)
      .then((response) => {
        self.state.activeDelete = false;
        self.state.ActiveID = '';
        DoNavigate(self, 'Orders', false, '', true, true);
      })
      .catch((error) => {});
  };

  downloadDocument = () => {
    /*application/octet-stream*/
    let self = this;
    //window.open('about:blank', 'Downloading');
    Requests.downloadDocument(2, {id: this.state.record.SerNr})
      .then((response) => {
        if (response.file !== '') {
          let blob = b64toBlob(response.file, 'application/pdf');
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          // the filename you want
          //a.download = response.name;
          //  a.target = '_blank';
          document.body.appendChild(a);
          window.open(url, 'Downloading');
          //window.URL.revokeObjectURL(url);
        } else {
          global.messageBox({
            showMessage: true,
            statusMessage: translate('DocumentNotFound'),
          });
        }
      })
      .catch((error) => {});
  };

  render() {
    let self = this;
    return (
      <WindowWrap>
        <InspectWindow
          title={translate('Order')}
          window={this}
          headerfields={OrderHeaderFields(this)}
          record={this.state.record}
          onClick={this.handleInputClick}
          allowDelete={true}
          allowPrint={IsHRWeb()}
          hasApprovals={this.state.hasapprovals == 1}
          backButton={() => goBack(self, self.ScreenName)}
        />

        {this.state.activeDelete && (
          <Modal transparent={true}>
            <YesNoWindow
              question={translate('RemoveQuestion')}
              yes={() => this.deleteRecord()}
              no={() => this.setState({activeDelete: false})}
            />
          </Modal>
        )}
      </WindowWrap>
    );
  }
}

function Orders() {
  return (
    <Drawer.Navigator
      style={{background: 'white'}}
      screenOptions={{headerShown: false}}
      backBehavior={GetDefaultBackBehaviour()}
      drawerStyle={{display: 'none'}}
    >
      <Drawer.Screen
        name="OrdersList"
        component={OrdersList}
        options={{
          title: translate('Orders'),
        }}
      />
      <Drawer.Screen
        name="OrdersRecord"
        component={OrdersRecord}
        backBehavior={GetDefaultBackBehaviour()}
        options={{
          title: translate('Order'),
        }}
        getId={({params}) => params.id}
      />
    </Drawer.Navigator>
  );
}

export default Orders;
